
import { EditorToolbar } from './EditorToolbar';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Image from '@tiptap/extension-image';
import Link from '@tiptap/extension-link';
import Placeholder from '@tiptap/extension-placeholder';
import CodeBlockLowlight from '@tiptap/extension-code-block-lowlight';
import { Table, TableRow, TableCell, TableHeader } from '@tiptap/extension-table';
import Typography from '@tiptap/extension-typography';
import CharacterCount from '@tiptap/extension-character-count';
import Youtube from '@tiptap/extension-youtube';
import { common, createLowlight } from 'lowlight';

const lowlight = createLowlight(common);

/**
 * Block editor powered by TipTap.
 */
export const BlockEditor = () => {
  const editor = useEditor({
    extensions: [
      StarterKit.configure({
        codeBlock: false,
      }),
      Image,
      Link.configure({
        openOnClick: false,
      }),
      Placeholder.configure({
        placeholder: 'Start writing...',
      }),
      CodeBlockLowlight.configure({
        lowlight,
      }),
      Table.configure({
        resizable: true,
      }),
      TableRow,
      TableHeader,
      TableCell,
      Typography,
      CharacterCount,
      Youtube,
    ],
    content: '',
    editorProps: {
      attributes: {
        class: 'w-full min-h-[500px] bg-transparent border-none outline-none resize-none prose prose-lg dark:prose-invert max-w-none focus:outline-none p-4',
      },
    },
  });

  return (
    <div className="space-y-4">
      <EditorToolbar editor={editor} />
      <div className="border rounded-md bg-background shadow-sm min-h-[500px]">
        <EditorContent editor={editor} className="text-lg text-foreground" />
      </div>
    </div>
  );
};
